import React from "react"
import { Box, Grid } from "@mui/material"
import LockingSystemComponentGroup from "./LockingSystemComponentGroup"
import Button from "components/Buttons/Button"
import Price from "components/Price"
import MiniMatrix from "./MiniMatrix"

import { LockingSystemReducerState } from "reducers/lockingSystemReducer"
import {
	LockingSystemCharges,
	LockingSystemPreviewProduct,
} from "@secureo/common/typings/LockingSystem"

import Icon from "@mdi/react"
import { mdiContentSave, mdiShareVariant, mdiFileDocumentOutline, mdiTagOutline } from "@mdi/js"

import getDeliveryTimeWorkDaysString from "@secureo/common/utils/commerceTools/formatters/getDeliveryTimeWorkDaysString"

const CostOverview = ({ totalGrossPriceCents, deliveryTimeWorkDays }: PriceProps) => {
	return (
		<div style={{ minHeight: 170 }}>
			<Box mb={3} style={{ display: "flex", alignItems: "center" }}>
				<Icon path={mdiTagOutline} size={1} color="#4691CE" />{" "}
				<Box ml={1}>
					<strong>Preisübersicht</strong>
				</Box>
			</Box>
			{/* <Box
				mt={1}
				pb={5}
				style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
			>
				<div>Voraussichtliche Lieferzeit</div>
				<div style={{ color: "#5DA67A" }}>
					{getDeliveryTimeWorkDaysString(deliveryTimeWorkDays)}
				</div>
			</Box> */}
			{/* <Box
				mt={2}
				style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
			>
				<div>Preis ohne MwSt.</div>
				<div>
					<Price priceInEuroCents={Infinity} />
				</div>
			</Box>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
				<div>Mwst.</div>
				<div>
					<Price priceInEuroCents={Infinity} />
				</div>
			</div> */}
			<Box
				mt={5}
				style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
			>
				<div>
					<strong>Gesamtpreis</strong>
				</div>
				<div>
					<strong>
						<Price priceInEuroCents={totalGrossPriceCents} />
					</strong>
				</div>
			</Box>
		</div>
	)
}

const LockingSystemComponentOverview = ({
	matrix,
	isLoading,
	isFrozen,
	componentsByUuid,
	matrixType,
	lockingComponentsUuids,
	keyComponentsUuids,
	taxRate,
	setComponentQuantity,
	setEditComponentModalUuid,
	availableLockingComponents,
	availableKeyComponents,
	charges,
	setSystemComponentName,
	setComponentProduct,
	setComponentSystem,
	setComponentOuterLength,
	setComponentInnerLength,
	saveLockingSystem,
	toggleShareModalIsOpen,
	totalGrossPriceCents,
	deliveryTimeWorkDays,
}: Props & PriceProps) => {
	return (
		<div style={{ marginTop: "4rem", maxWidth: 1280 }}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={7}>
					<Box
						p={3}
						style={{
							background: "white",
							boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
							borderRadius: 5,
						}}
					>
						<div style={{ display: "flex", alignItems: "center" }}>
							<Icon path={mdiFileDocumentOutline} size={1} color="#4691CE" />{" "}
							<Box ml={1}>
								<strong>Zusammenfassung Ihrer Schließanlage</strong>
							</Box>
						</div>
						<p>
							Hier sehen Sie eine Übersicht Ihrer konfigurierten Schließanlage.
							Überprüfen Sie nochmal genau Ihre Angaben - eine Schließanlage wird auf
							Ihre konkreten Wünsche für Sie angefertigt und ist vom Umtausch bzw.
							Widerruf grundsätzlich ausgeschlossen; bitte beachten Sie, dass spätere
							Reklamationen nicht mehr berücksichtigt werden können.
						</p>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<Button
								disabled={isLoading || isFrozen}
								onClick={saveLockingSystem}
								style={{ maxWidth: 150 }}
								size="small"
							>
								<Icon path={mdiContentSave} size={1} />
								<Box ml={1}>Speichern</Box>
							</Button>
							<Button
								onClick={toggleShareModalIsOpen}
								size="small"
								color="primary"
								style={{ maxWidth: 120 }}
							>
								<Icon path={mdiShareVariant} size={1} /> <Box ml={1}>Teilen</Box>
							</Button>
						</div>
					</Box>
				</Grid>
				<Grid item xs={12} md={5}>
					<Box
						p={3}
						style={{
							background: "white",
							boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
							borderRadius: 5,
						}}
					>
						<CostOverview
							totalGrossPriceCents={totalGrossPriceCents}
							deliveryTimeWorkDays={deliveryTimeWorkDays}
						/>
					</Box>
				</Grid>
			</Grid>
			<MiniMatrix
				matrix={matrix}
				matrixType={matrixType}
				componentsByUuid={componentsByUuid}
				lockingComponentsUuids={lockingComponentsUuids}
				keyComponentsUuids={keyComponentsUuids}
				setEditComponentModalUuid={setEditComponentModalUuid}
			/>

			{lockingComponentsUuids.length > 0 && (
				<div>
					<Box mb={1}>
						<h3 style={{ margin: 0 }}>Zylinderkonfigurationen</h3>
					</Box>
					<LockingSystemComponentGroup
						isFrozen={isFrozen}
						type="lock"
						isLoading={isLoading}
						componentsByUuid={componentsByUuid}
						componentUuids={lockingComponentsUuids}
						taxRate={taxRate}
						setComponentQuantity={setComponentQuantity}
						setEditComponentModalUuid={setEditComponentModalUuid}
						availableLockingComponents={availableLockingComponents}
						availableKeyComponents={availableKeyComponents}
						charges={charges}
						setSystemComponentName={setSystemComponentName}
						setComponentProduct={setComponentProduct}
						setComponentSystem={setComponentSystem}
						setComponentOuterLength={setComponentOuterLength}
						setComponentInnerLength={setComponentInnerLength}
					/>
				</div>
			)}

			{keyComponentsUuids.length > 0 && (
				<div>
					<Box mb={1} mt={2}>
						<h3 style={{ margin: 0 }}>Schlüsselkonfigurationen</h3>
					</Box>
					<LockingSystemComponentGroup
						isFrozen={isFrozen}
						type="key"
						isLoading={isLoading}
						componentsByUuid={componentsByUuid}
						componentUuids={keyComponentsUuids}
						taxRate={taxRate}
						setComponentQuantity={setComponentQuantity}
						setEditComponentModalUuid={setEditComponentModalUuid}
						availableLockingComponents={availableLockingComponents}
						availableKeyComponents={availableKeyComponents}
						charges={charges}
						setSystemComponentName={setSystemComponentName}
						setComponentProduct={setComponentProduct}
						setComponentSystem={setComponentSystem}
						setComponentOuterLength={setComponentOuterLength}
						setComponentInnerLength={setComponentInnerLength}
					/>
				</div>
			)}
		</div>
	)
}

interface Props {
	isLoading: boolean
	isFrozen: boolean
	matrix: LockingSystemReducerState["matrix"]
	matrixType: LockingSystemReducerState["matrixType"]
	componentsByUuid: LockingSystemReducerState["componentsByUuid"]
	lockingComponentsUuids: LockingSystemReducerState["lockingComponentsUuids"]
	keyComponentsUuids: LockingSystemReducerState["keyComponentsUuids"]
	taxRate: number
	setComponentQuantity?: (uuid: string, quantity: number) => void
	setEditComponentModalUuid?: (uuid: string) => void
	availableLockingComponents: LockingSystemPreviewProduct[]
	availableKeyComponents: LockingSystemPreviewProduct[]
	charges: LockingSystemCharges
	setSystemComponentName: (uuid: string, name: string) => void
	setComponentProduct: (
		uuid: string,
		lockingSystemPreviewProduct: LockingSystemPreviewProduct,
	) => void
	setComponentSystem: (uuid: string, selectedSystem: string) => void
	setComponentOuterLength: (uuid: string, selectedOuterLength: number) => void
	setComponentInnerLength: (uuid: string, selectedInnerLength: number) => void
	saveLockingSystem: () => void
	toggleShareModalIsOpen: () => void
	deliveryTimeWorkDays: number
}

interface PriceProps {
	totalGrossPriceCents: number
	deliveryTimeWorkDays: number
}

export default LockingSystemComponentOverview
